import React from 'react';
import {Card} from '@rn-vui/themed';

import {JoinMoreRewardsCTA} from '../../../components/rewards/JoinMoreRewards';
import Text from '../../../components/themed/Text';
import {AppRoute} from '../../../models/AppRoute';
import type {RouteNavigatorScreenProps} from '../../../models/navigationTypes';
import {rewardsMarketingName} from '../../../utils/rewards';

function CartJoinRewards({
  navigation,
}: {
  navigation: RouteNavigatorScreenProps<AppRoute.CART>['navigation'];
}) {
  return (
    <Card noMargin gap={12} variant="outlined">
      <Text noMargin variant="heading2">
        Save with {rewardsMarketingName}
      </Text>
      <Text variant="body2">
        Join {rewardsMarketingName} today and start enjoying free member benefits at your
        fingertips.
      </Text>
      <JoinMoreRewardsCTA navigation={navigation} />
    </Card>
  );
}

export default CartJoinRewards;
